import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./User";

const store = configureStore({
	reducer: userReducer,
});

export default store;
